import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Params, Router, UrlSerializer } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../../../environments/environment';
import { Formality } from '../../models/quotation-model/catalogs/formality.model';
import { FormalityInsert } from '../../models/quotation-model/main/formality-insert.model';
import { QuotationFormalityAmount } from '../../models/quotation-model/main/quotation-formality-amount.model';

@Injectable({
  providedIn: 'root',
})
export class QuotationFormalityService {
  public URL_API = environment.apiURL;
  constructor(
    private http: HttpClient,
    private router: Router,
    private serializer: UrlSerializer,
  ) {}

  getFormalitys(): Observable<Formality[]> {
    return this.http.get<Formality[]>(this.URL_API + '/Formality');
  }

  createFormality(objInsert: FormalityInsert) {
    return this.http.post<FormalityInsert>(this.URL_API + '/Formality/Insert', objInsert);
  }

  getFormalityAmount(quotationId: number): Observable<QuotationFormalityAmount> {
    var url2 = this.URL_API + '/Formality/GetAmount?quotationId=' + quotationId;
    return this.http.get<QuotationFormalityAmount>(url2);
  }
}
